import React, { useState, useEffect } from 'react';

const List = (props) => {
  const [labels, setLabels] = useState(props.labels || []);
  const [fields, setFields] = useState(props.fields || []);
  const [sortables, setSortables] = useState(props.sortables || []);
  const [data, setData] = useState(props.data || []);
  const [sort, setSort] = useState(-1);
  const [sortedBy, setSortedBy] = useState(null);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const sortTable = (col) => {
    const field = fields[col];
    const sortFunction = (a, b) => {
      const aVal = a[field].value ? a[field].value : a[field];
      const bVal = b[field].value ? b[field].value : b[field];
      if (aVal < bVal) return -1 * sort;
      if (aVal > bVal) return 1 * sort;
      return 0;
    };

    let toBeSortedItems = [...data];
    let numericItems = toBeSortedItems.filter((i) =>
      i[field].value ? !isNaN(i[field].value) : !isNaN(i[field])
    );
    let alphaItems = toBeSortedItems.filter((i) =>
      i[field].value ? isNaN(i[field].value) : isNaN(i[field])
    );
    numericItems.sort(sortFunction);
    alphaItems.sort(sortFunction);
    const sortedItems = numericItems.concat(alphaItems);

    setData(sortedItems);
    setSort(sort * -1);
    setSortedBy(col);
  };

  const onRowClick = (data, index) => {
    if (props.onRowClick) props.onRowClick(data, index);
  };

  const headings = labels.map((k, ki) => {
    const active = sortedBy === ki ? 'active' : '';
    const arrow = sort === -1 ? '↑' : '↓';
    const sortable = sortables.indexOf(fields[ki]) > -1 ? true : false;

    return sortable ? (
      <th
        key={'th-' + ki}
        onClick={() => sortTable(ki)}
        className={'text-center text-nowrap cursor-pointer' + active}>
        {k}{' '}
        {active && (
          <small className='badge badge-pill badge-primary'>{arrow}</small>
        )}
      </th>
    ) : (
      <th key={'th-' + ki} className='text-center'>
        {k}
      </th>
    );
  });

  const rows = data?.map((d, di) => {
    const rowClass = d?.rowClass ? d.rowClass : '';
    let cols = fields?.map((k, ki) => {
      const value = d[k].value ? d[k].value : d[k];
      const label = d[k].label ? d[k].label : value;
      return (
        <td
          onClick={() => onRowClick(d, di)}
          key={'td-' + di + '-' + ki}
          style={{ maxWidth: '50%' }}
          className='text-center align-middle small'>
          {label}
        </td>
      );
    });
    return (
      <tr key={'tr-' + di} className={rowClass}>
        {cols}
      </tr>
    );
  });

  return (
    <div className='table-responsive'>
      <table className='table table-sm border-2 border-top table-hover'>
        <thead className=''>
          <tr>{headings}</tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default List;
